import EventEmitter from 'src/helpers/EventEmitter'
import { TweenMax } from 'gsap'
const THREE = require('three') 
import frag from '@/shaders/movieclip/fragment.glsl'
import vert from '@/shaders/movieclip/vertex.glsl'
import {findWhere} from '@/helpers/ArrayUtils'

const Events = {}

class MovieClip extends THREE.Group {


  // SETUP - - - - - - - - - - - - - - - - - - - - - - - 

  constructor(config) {

    super();

    Object.assign(this, EventEmitter)

    let defaultConfig = {
      
      frame_width: 0,
      frame_height: 0,
      spritesheet_width: 0,
      spritesheet_height: 0,

      transparent: true,
      frames: null,
      texture: null,
      fps: 25

    }

    this.config = Object.assign(defaultConfig, config);
    this.time = null; 
    this.frame = {
      current: 0,
      loop: 0,
      start: 0,
      end: 0
    };

    this.setup();
  }

  setup() {

    this.geometry = new THREE.PlaneGeometry(this.config.frame_width , this.config.frame_height , 32);
    this.material = new THREE.ShaderMaterial({
      uniforms: {
        texture: {
          type: 't',
          value: this.config.texture
        },
        // tex width / height
        tSize: {
          type: 'v2',
          value: new THREE.Vector2(this.config.spritesheet_width, this.config.spritesheet_height)
        },
        // frame trim width / height
        fTrimSize: {
          type: 'v2',
          value: new THREE.Vector2()
        },
        // frame original width / height
        fOriginalSize: {
          type: 'v2',
          value: new THREE.Vector2(this.config.frame_width, this.config.frame_height)
        },
        // frame x / y offset
        fOffset: {
          type: 'v2',
          value: new THREE.Vector2()
        },
        fTrimOffset: {
          type: 'v2',
          value: new THREE.Vector2()
        },
        opacity: {
          type: 'f',
          value: 1.0
        }
      },
      transparent: this.config.transparent, 
      vertexShader: vert,
      fragmentShader: frag
    });

    this.mesh = new THREE.Mesh(this.geometry, this.material  );
    this.add(this.mesh);
  }

  gotoAndStop(index) {
    var frame = this.getFrame(index);
    this.material.uniforms.fTrimSize.value.x = frame.spriteSourceSize.w;
    this.material.uniforms.fTrimSize.value.y = frame.spriteSourceSize.h;
    this.material.uniforms.fOffset.value.x = (frame.frame.x - frame.spriteSourceSize.x );
    this.material.uniforms.fOffset.value.y = (frame.frame.y - frame.spriteSourceSize.y );
    this.material.uniforms.fTrimOffset.value.x = frame.spriteSourceSize.x;
    this.material.uniforms.fTrimOffset.value.y = frame.spriteSourceSize.y;
  }

  getFrame(frame) {
    if(typeof frame === "number"){
      return this.config.frames[frame];
    } else if (typeof frame === "string") {
      return findWhere(this.config.frames,  {filename: frame});
    }
  }

  stop(frame) {
    frame = frame || this.frame.current;
    this.looping = false;
    TweenMax.killTweensOf(this.frame, {
      current: true
    });
    this.gotoAndStop(frame);
  }

  play(current, count, onDone) {

    this.frame.end = (this.config.frames.length - 1); //this.getFrameForLabel(loopEnd);  
    this.frame.count = count || -1;
    this.onDone = onDone || null;
    this.looping = true;

    TweenMax.killTweensOf(this.frame, {
      current: true
    });

    this.frame.current = current || 0; //this.getFrameForLabel(gotoFrame); 
    this.gotoAndLoop(this.frame.current, null, null, this.frame.count, onDone, null);
  }

  gotoAndLoop(gotoFrame, loopStart, loopEnd, loopCount, onDone, speed) {

    this.frame.end = loopEnd || (this.config.frames.length - 1); //this.getFrameForLabel(loopEnd);  
    this.frame.start = loopStart || this.frame.current; //this.getFrameForLabel(loopStart);
    this.frame.count = loopCount || -1;
    this.onDone = onDone || null;
    this.speed = speed || 1;
    this.looping = true;

    TweenMax.killTweensOf(this.frame, {
      current: true
    });
    this.frame.current = gotoFrame || 0; //this.getFrameForLabel(gotoFrame);

    var doneFunc = onDone;
    var duration = this.speed * (Math.abs(this.frame.current - this.frame.end) / this.config.fps);
    TweenMax.to(this.frame, duration, {
        current: this.frame.end,
        ease: 'Linear.easeNone',
        onUpdate: this.onUpdate,
        onComplete: this.onLoop
    });
  }

  gotoAndPlayRange(gotoFrame, endFrame, onDone, speed) {
    if (gotoFrame === null) {
        gotoFrame = this.frame.current;
    }

    this.frame.end = endFrame; //this.getFrameForLabel(endFrame);
    this.frame.start = gotoFrame; // this.getFrameForLabel(gotoFrame);
    this.speed = speed || 1;
    this.frame.count = 0;
    this.onDone = onDone || null;
    this.looping = true;

    TweenMax.killTweensOf(this.frame, {
      current: true
    });
    this.frame.current = this.frame.start;

    var doneFunc = onDone;
    var duration = this.speed * (Math.abs(this.frame.start - this.frame.end) / this.config.fps);
    TweenMax.to(this.frame, duration, {
      current: this.frame.end,
      ease: 'Linear.easeNone',
      onUpdate: this.onUpdate,
      onComplete: function() {
        if (doneFunc) {
            doneFunc();
        }
      }
    }); 
  }

  onLoop = () => {

    if (this.frame.count > -1) {
      this.frame.count--;
      if (this.frame.count === -1) {
        this.looping = false;
        if (this.onDone) {
            this.onDone();
        }
        return;
      }
    }

    TweenMax.killTweensOf(this.frame, {
      current: true
    });

    this.frame.current = this.frame.start;
    var duration = this.speed * (Math.abs(this.frame.start - this.frame.end) / this.config.fps);
    TweenMax.to(this.frame, duration, {
      current: this.frame.end,
      ease: 'Linear.easeNone',
      onUpdate: this.onUpdate,
      onComplete: this.onLoop
    });
  }

  onUpdate = () => {
    this.gotoAndStop(Math.round(this.frame.current));
  }

  setOpacity(num){
    this.material.uniforms.opacity.value = num;
  }

}

MovieClip.Events = Events

export default MovieClip